// CTQ marker when a row is added to tombstone list
// Custom data: Number of total items in tombstone for this folder after add
export var AddToTombstoneCTQName = 'AddToTombstone';
// CTQ marker when a row is removed from tombstone list
// Custom data: Number of total items in tombstone for this folder after remove
export var RemoveFromTombstoneCTQName = 'RemoveFromTombstone';
// CTQ marker when all rows are removed from tombstone list
export var RemoveAllFromTombstoneCTQName = 'RemoveAllFromTombstone';
// CTQ marker when we clear tombstone for a folder (due to reload notification or removing all tables for folder)
// Custom data: Number of total items in tombstone for this folder before clearing
export var ClearTombstoneForFolderCTQName = 'ClearTombstoneForFolder';
//# sourceMappingURL=ctqNames.js.map